import React from 'react';
import { Modal } from "@mui/material";
import styled, { css } from "styled-components";
import { StyledModal } from "../../../styles/matieralui/Modal";
import { Theme } from "../../../styles/Theme";

export const StyledFullScreenModal = styled(Modal)`
    &.MuiModal-root {
        padding-left: 0 !important;
        padding-right: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }
    .MuiBackdrop-root {
        background-color: ${Theme.colors.base};
        transition: none !important;
    }
`

export const FullScreenModal = ({ open, onClose, label, description, children, fullWidth = false, className }) => {
    return (
        <StyledFullScreenModal
            open={open}
            onClose={onClose}
            aria-labelledby={label}
            aria-describedby={description}
            fullWidth={fullWidth}
            className={className}>
            {children}

        </StyledFullScreenModal>
    )
}